import React__default from 'react';
import { View, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';

const AppDot = _ref => {
  let {
    count,
    completedCount,
    forcedValue,
    dotSize = 4,
    dotStyle
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const GenerateColor = p => {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
    if (p < 33) return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.red;else if (p >= 33 && p < 100) return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.orangeBtnColor;else if (p === 100) return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.green;
  };
  const styles = styleGenerator({
    currentTheme,
    count,
    completedCount,
    forcedValue,
    GenerateColor,
    dotSize
  });
  return count > 0 || forcedValue ? /*#__PURE__*/React__default.createElement(View, {
    style: [styles.dot, dotStyle]
  }) : null;
};
const styleGenerator = _ref2 => {
  let {
    currentTheme,
    count,
    completedCount,
    forcedValue,
    GenerateColor,
    dotSize
  } = _ref2;
  return StyleSheet.create({
    dot: {
      position: "relative",
      borderRadius: dotSize,
      width: dotSize,
      height: dotSize,
      padding: 2,
      backgroundColor: forcedValue ? GenerateColor(forcedValue * 100) : count > 0 ? GenerateColor(completedCount / count * 100) : GenerateColor(0)
    }
  });
};
AppDot.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppDot",
  "props": {
    "dotSize": {
      "defaultValue": {
        "value": "4",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "When passed, it changes the radius of the dot"
    },
    "count": {
      "required": true,
      "tsType": {
        "name": "number"
      },
      "description": "Count used to logically generate a completion percentage based on completedCount - <completedCount />\n     <count></count>"
    },
    "completedCount": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Count used to logically generate a completion percentage based on the overall count - <completedCount />\n     <count></count>"
    },
    "forcedValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "When passed the completedCount and count are overriden by a float between 0 to 1"
    },
    "dotStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply to the dot"
    }
  }
};

export { AppDot as A };
